import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["open"];
import styled from 'styled-components';
import { FLINT } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIExpandableSection from 'UIComponents/accordion/UIExpandableSection';

/**
 * Shared expandable section-related styled components.
 */

/**
 * The header of the `UIExpandableSection`.
 * @ts-expect-error defaultProps is defined */
import { jsx as _jsx } from "react/jsx-runtime";
export const ExpandableHeader = styled(UIExpandableSection.defaultProps.Header).withConfig({
  displayName: "ExpandableComponents__ExpandableHeader",
  componentId: "hy1y1c-0"
})(["border:none;padding:0;&::after{content:none;}"]);

/**
 * The opener, which wraps the `Caret` and `Title` of the
 * `UIExpandableSection`.
 * @ts-expect-error defaultProps is defined */
export const ExpandableOpener = styled(UIExpandableSection.defaultProps.Opener).withConfig({
  displayName: "ExpandableComponents__ExpandableOpener",
  componentId: "hy1y1c-1"
})(["flex-direction:row-reverse;justify-content:space-between;padding:0;"]);

/**
 * The +/- icons on a group. Indicates that it's an expandable section.
 */
export const ExpandableCaret = _ref => {
  let {
      open
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UIIcon, Object.assign({}, rest, {
    name: open ? 'minus' : 'add',
    size: 10,
    color: FLINT
  }));
};